import axios from "../services/APIUtils";
import { apiConfig } from "./config";
import { parseList } from "./utility";

const GetMasterCommercialType = async function () {
  try {
    /* axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")};`; */
    const response = await axios.get(
      `${apiConfig}/api/Master/GetMasterCommercialType`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetMasterCommercialPrefix = async function () {
  try {
    /* axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")};`; */
    const response = await axios.get(
      `${apiConfig}/api/Master/GetMasterCommercialPrefix`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetMasterCountry = async function () {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Master/GetMasterCountry`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetMasterProvince = async function () {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Master/GetMasterProvince`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetMasterUser = async function () {
  try {
    const response = await axios.get(`${apiConfig}/api/Master/GetMasterUser`);
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetContactPoint = async function () {
  try {
    const response = await axios.get(`${apiConfig}/api/Master/GetContactPoint`);
    let data = parseList(response);
    return data;
  }
  catch(error) {
    console.log(error);
    return error;
  }
}

const GetMasterCategory = async function () {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Master/GetMasterCategories`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetMasterSubCategory = async function (id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Master/GetMasterSubCategoryByCategoryId/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetMasterExchangeRate = async function (ProjectId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetProjectExchangRate/${ProjectId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetMasterIncoTerm = async function () {
  try {
    const response = await axios.get(`${apiConfig}/api/Master/GetMstIncoTerm`);
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};
const GetCurrency = async function (symbols,date) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Master/GetExchangeRatesOpenAPIBOT?symbols=${symbols}&period=${date}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const masterservice = {
  GetCurrency,
  GetMasterCommercialType,
  GetMasterCommercialPrefix,
  GetMasterCountry,
  GetMasterProvince,
  GetMasterUser,
  GetMasterCategory,
  GetMasterSubCategory,
  GetMasterExchangeRate,
  GetMasterIncoTerm,
  GetContactPoint
};
